import { TipoConsulta } from './../enum/tipoConsulta';
export class SessaoConsultaModel {
  Tipo: TipoConsulta;
  Consulta: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/sessao-consulta.model.ts